var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-modal", { attrs: { id: "busModal", "hide-footer": true } }, [
    _c(
      "div",
      { attrs: { id: "busForm" } },
      [
        _c(
          "div",
          { staticClass: "formTitle" },
          [
            _c("svg-image", { attrs: { image: "iconBus" } }),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(_vm.$t("shuttle.modal.head")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "groupLabel" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("shuttle.modal.lpoint")))]),
        ]),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", [
              _c("div", {
                staticClass: "point",
                domProps: { innerHTML: _vm._s(_vm.$t("shuttle.modal.p1")) },
              }),
            ]),
            _vm._v(" "),
            _c("b-col", [
              _c("div", {
                staticClass: "point",
                domProps: { innerHTML: _vm._s(_vm.$t("shuttle.modal.p2")) },
              }),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", [
              _c("div", {
                staticClass: "point",
                domProps: { innerHTML: _vm._s(_vm.$t("shuttle.modal.p3")) },
              }),
            ]),
            _vm._v(" "),
            _c("b-col", [
              _c("div", {
                staticClass: "point",
                domProps: { innerHTML: _vm._s(_vm.$t("shuttle.modal.p4")) },
              }),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "groupLabel" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("shuttle.modal.lform")))]),
        ]),
        _vm._v(" "),
        _c(
          "b-form",
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("shuttle.modal.fpoint"),
                  "label-for": "",
                  description: _vm.$t("shuttle.modal.fpointdesc"),
                },
              },
              [
                _c(
                  "b-form-select",
                  [
                    _c("b-form-select-option", { attrs: { value: "JOG1" } }, [
                      _vm._v("Plaza Ambarrukmo Yogyakarta"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "JOG2" } }, [
                      _vm._v("Abu Bakar Ali Parking Area"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "JOG3" } }, [
                      _vm._v("Televisi Republik Indonesia Yogyakarta"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "MGL1" } }, [
                      _vm._v("Armada Town Square Magelang"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("shuttle.modal.freturn"),
                  "label-for": "",
                  description: _vm.$t("shuttle.modal.freturndesc"),
                },
              },
              [
                _c(
                  "b-form-select",
                  [
                    _c("b-form-select-option", { attrs: { value: "R1" } }, [
                      _vm._v("11.00 WIB (GMT+7)"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "R2" } }, [
                      _vm._v("12.00 WIB (GMT+7)"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "R3" } }, [
                      _vm._v("13.00 WIB (GMT+7)"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "clearfix" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      block: "",
                      type: "submit",
                      variant: "primary",
                      size: "lg",
                    },
                  },
                  [
                    _c("b-spinner", { attrs: { small: "", type: "grow" } }),
                    _vm._v(" " + _vm._s(_vm.$t("shuttle.modal.fbtn"))),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/BusModal.vue